import React, { useState } from 'react';
import './UserDailyRankingData.scss';
import defaultImage from '../../images/avatars/spaceman5.png'

const UserDailyRankingData = ({ current }) => {
    // 添加状态来控制是否显示所有数据
    const [showAll, setShowAll] = useState(false);

    // 处理排行榜项点击事件
    const handleRankingItemClick = (twitchUsername, item) => {
        console.log('点击了排行榜项目', item);
        // console.log('Twitch用户名:', twitchUsername);

        if (twitchUsername) {
            console.log('正在打开Twitch页面:', `https://www.twitch.tv/${twitchUsername}`);
            // 使用try-catch捕获可能的错误
            try {
                window.open(`https://www.twitch.tv/${twitchUsername}`, '_blank');
            } catch (error) {
                // console.error('打开Twitch页面时出错:', error);

                // 备用方法：创建并触发一个链接
                const link = document.createElement('a');
                link.href = `https://www.twitch.tv/${twitchUsername}`;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            // console.warn('未找到有效的Twitch用户名，无法打开链接');
        }
    };

    // 处理展开/收起更多数据
    const handleToggleShowAll = () => {
        setShowAll(!showAll);
    };

    // console.log('当前排行榜数据:', current?.latestLeaderboard);

    // 获取要显示的数据
    const getDisplayData = () => {
        if (!current?.latestLeaderboard) return [];

        if (showAll || current.latestLeaderboard.length <= 10) {
            return current.latestLeaderboard;
        }

        return current.latestLeaderboard.slice(0, 10);
    };

    // const displayData = getDisplayData();
    // const hasMoreData = current?.latestLeaderboard?.length > 10;

    const displayData = getDisplayData();
    const hasMoreData = current?.latestLeaderboard?.length > 10;

    return (
        <div className="twitch-rankings">
            <div className="rankings-title">
                Live Twitch Streamer Rankings
            </div>
            <div className="rankings-summary">
                <div className="summary-title">
                    <span className="label">Ranking based on composite score.</span>
                </div>
                <div className="summary-item">
                    <span className="label break-lines">The ranking will be calculated based on the comprehensive score of the live streaming viewing duration, live streaming revenue, and the number of live streaming days.</span>
                </div>

                <div className="summary-bottom">
                    <span className="label ">Rankings update daily</span>
                </div>
            </div>
            <div className="rankings-slider">
                {current && current.latestLeaderboard && current.latestLeaderboard.length > 0 ? (
                    <>
                        {displayData.map((item, index) => {
                            // 获取Twitch用户名
                            const twitchUsername = item?.user?.connectedAccounts?.twitch?.username;

                            return (
                                <div
                                    key={index}
                                    className="ranking-item"
                                    onClick={(e) => {
                                        e.stopPropagation(); // 阻止事件进一步传播
                                        handleRankingItemClick(twitchUsername, item);
                                    }}
                                    style={{
                                        cursor: 'pointer',
                                        position: 'relative', // 确保z-index生效
                                        zIndex: 5 // 提高z-index确保元素可点击
                                    }}  // 添加鼠标悬停指针样式
                                    title={`Visit ${twitchUsername}'s Twitch channel`}  // 添加提示文本
                                >
                                    <div className="rank">#{item.rank}</div>
                                    <img
                                        src={item?.user?.connectedAccounts?.twitch?.profile_image_url}
                                        alt={twitchUsername}
                                        className="avatar"
                                        onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                                    />
                                    <div className="user-info">
                                        <div className="name">
                                            {twitchUsername}
                                        </div>
                                        <div className="fans">
                                            {item?.user?.connectedAccounts?.twitch?.followers} Fans
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        {/* 显示更多/收起按钮 */}
                        {hasMoreData && (
                            <div
                                className="show-more-item"
                                onClick={handleToggleShowAll}
                                style={{
                                    transition: 'all .25s ease-in',
                                    position: 'relative',
                                    width: '100%', // 与 ranking-item 宽度一致
                                    height: '30px', // 比 ranking-item 更矮
                                    background: 'none',
                                    border: 0,
                                    outline: 0,
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    opacity: 0.4,
                                    padding: '0',
                                    textAlign: 'center',
                                    color: '#fff',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    margin: '2px 0', // 减少上下边距
                                    display: 'flex', // 使用 flex 布局
                                    alignItems: 'center', // 垂直居中
                                    justifyContent: 'center', // 水平居中
                                    borderRadius: '4px'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.opacity = '1';
                                    e.target.style.background = 'rgba(0, 0, 0, 0.2)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.opacity = '0.4';
                                    e.target.style.background = 'none';
                                }}
                            >
                                {showAll ? 'Hide' : 'More'}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="no-data">No data available</div>
                )}
            </div>
        </div>
    );
};

export default UserDailyRankingData;